export type TimelineEventProps = {
  /** Label displayed as the header of the event. */
  header?: React.ReactNode
  /** Date in which the event happend, it's shown with the right date format. */
  date?: string | number | Date
  /** An element rendered on the left hand side of the header title. */
  headerLeftElement?: React.ReactNode
  /** An element rendered on the right hand side of the header title */
  headerRightElement?: React.ReactNode
  /** The status badge located on the top right corner */
  statusBadge?: React.ReactNode
  /** Children React nodes are rendered below the headerTitle */
  children?: React.ReactNode
  /** Returns true if data is loading */
  isLoading?: boolean
}

export enum EventTypeVariantEnum {
  lifecycle = 'lifecycle',
  meeting = 'meeting',
  conversation = 'conversation',
  emailCaptured = 'emailCaptured',
}

export type EventTypeVariantLiteral = `${EventTypeVariantEnum}`

export type TimelineEventCardProps = {
  eventType: EventTypeVariantLiteral
  /** Date in which the event happend, it's shown with the right date format. */
  date: string | number | Date
  /** The status badge located on the top right corner */
  statusBadge?: React.ReactNode
  /** Returns true if data is loading */
  isLoading?: boolean
  /** Children React nodes are rendered below the headerTitle */
  children?: React.ReactNode
}
